import $ from 'jquery';
window.$ = window.jQuery = $;

$(document).foundation()
